import { useState, useEffect } from "react";
import { Alert, Container, Image } from "react-bootstrap";
import { getAuth, onAuthStateChanged } from "@firebase/auth";
import loadingGif from "../components/img/loading.gif";
import { FaCheckCircle } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import fetchUserDetails from "../components/Functions/FetchUserDetails";
import sendEmail from "../components/Functions/SendEmail";

const Success = () => {
  const { state } = useLocation();
  const propertyId = state?.propertyId;
  const ref = state?.newBookingId;
  const lastEmailSentTime = localStorage.getItem("lastEmailSentTime");
  const currentTime = new Date().getTime();

  const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [property, setProperty] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [guests, setGuests] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [cost, setCost] = useState(0);
  const [variablesLoaded, setVariablesLoaded] = useState(false);

  // Listen for auth state
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user || null);
    });
    return () => unsubscribe();
  }, []);

  // Load user & booking details
  useEffect(() => {
    const loadDetails = async () => {
      if (!user) return;

      try {
        const details = await fetchUserDetails(ref, propertyId, user);
        if (!details) return;
        console.log(details.cost);
        console.log(details.guests);

        setStartDate(details.startDate);
        setEndDate(details.endDate);
        setProperty(details.propertyName);
        setName(details.name);
        setEmail(details.email);
        setPhoneNumber(details.phoneNumber);
        setVariablesLoaded(true);
        setCost(details.cost);
        setGuests(details.guests);
      } catch (error) {
        console.error("Error loading details:", error);
        setLoading(false);
      }
    };

    loadDetails();
  }, [user, ref, propertyId]);

  // Send email once variables are loaded
  useEffect(() => {
    if (!variablesLoaded) return;

    const send = async () => {
      try {
        const emailData = {
          property,
          email,
          ref,
          name,
          startDate,
          endDate,
          phoneNumber,
          cost,
          guests,
        };

        if (
          !lastEmailSentTime ||
          currentTime - lastEmailSentTime >= 5 * 60 * 1000
        ) {
          const success = await sendEmail(emailData); // must accept a plain object
          if (success) {
            setEmailSent(true);
            localStorage.setItem("lastEmailSentTime", currentTime);
          } else {
            setEmailSent(false);
          }
        } else {
          console.log("Only one email can be sent every 10 mins");
        }
      } catch (error) {
        console.error("Error sending email:", error);
      } finally {
        setLoading(false);
      }
    };

    send();
  }, [
    variablesLoaded,
    property,
    email,
    ref,
    name,
    startDate,
    endDate,
    phoneNumber,
    cost,
    guests,
    currentTime,
    lastEmailSentTime
  ]);

  return (
    <Container
      className="d-flex align-items-center justify-content-center mt-5"
      style={{ height: "100vh" }}
    >
      {loading ? (
        <Image
          src={loadingGif}
          alt="Loading"
          width="140"
          height="auto"
          className="loadingGif"
        />
      ) : emailSent ? (
        <Alert variant="success">
          <Alert.Heading>Booking Confirmed!</Alert.Heading>
          <p>You’ve successfully booked sea breeze apartment</p>
          <p>Your Booking : {ref}</p>
          <br />
          <p>Start Date: {startDate}</p>
          <p>End Date: {endDate}</p>
          <p>Guests: {guests}</p>
          <p>Cost: {cost}</p>
          <br />
          <p>
            You will receive an email shortly with your booking confirmation and
            booking reference number.
          </p>
          <p>For any booking enquiries please contact:</p>
          <p>07815 870 350</p>
          <p>robpristine@gmail.com</p>
          <div className="d-flex justify-content-center">
            <FaCheckCircle size={60} />
          </div>
          <a href="/">Return home</a>
        </Alert>
      ) : (
        <>
          {!loading && !emailSent && (
            <Alert variant="info">
              <Alert.Heading>Loading...</Alert.Heading>
              <p className="mt-2">
                If this error persists please contact supprot@clever-robin.com
              </p>
              <p>Or contact the host directly</p>
              <a href="/">Return home</a>
            </Alert>
          )}
        </>
      )}
    </Container>
  );
};

export default Success;
